import { format } from 'date-fns';

export function formatBirthday(date) {
    if (!date) return '';
    return date.split('T')[0];
}

export function formatDate(date) {
    if (!date) return '—';
    return format(new Date(date?.replace('Z', '')), 'dd/MM/yyyy');
}
